import { useState } from "react";
import CustomTooltipIcon from "../../components/customTooltipIcon/customTooltipIcon";
import DynamicTable from "./dynamicTable";

export default function GroupDataTable(tables, keys = []) {
  const [updateCount, setUpdateCount] = useState(0);

  return keys?.map((k) => {
    return (
      <>
        <h3>
          <span>{tables[k]?.title}</span>
          {tables[k]?.tooltipText && (
            <CustomTooltipIcon
              size="big"
              tooltipText={tables[k]?.tooltipText}
            />
          )}
        </h3>
        {DynamicTable({
          inputTableData: tables[k]?.state[0],
          updateParentTableData: tables[k]?.state[1],
          setIsError: tables[k]?.error[1],
          valueType: tables[k]?.valueType,
          updateCount,
          setUpdateCount,
        })}
      </>
    );
  });
}
